<template>
  <el-card v-loading="loading" shadow="never">
    <slot slot="header"></slot>
    <ul>
      <li v-for="(row, index) in datalist.items" :key="index">
        <span class="index">{{ index + 1 }}</span>
        <el-link
          class="name"
          type="primary"
          @click="
            $router.push({
              path: 'detail',
              query: { ...params, dealer: row.name },
            })
          "
          >{{ row.name }}</el-link
        >
        <label style="flex: 1" />
        <div class="amount">
          <label class="value">{{ row.value }}</label>
          <label class="count">{{ row.count }}</label>
          <label class="quantity">{{ row.quantity }}</label>
          <el-link
            type="primary"
            @click="
              $router.push({
                name: 'ffa481401b3c4d62a9ad69c9057d99d7',
                params: { ...params, dealer: row.name },
              })
            "
          >
            详情
          </el-link>
        </div>
      </li>
    </ul>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      datalist: [],
    };
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.trend.dealer
        .ranking(this.params)
        .then((res) => {
          this.datalist = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  li + li {
    margin-top: 10px;
  }
  li {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .index {
      flex-shrink: 0;
      background-color: #ccc;
      color: #fff;
      width: 16px;
      height: 16px;
      margin-right: 10px;
      display: inline-block;
      text-align: center;
    }
    &:first-child {
      .index {
        background: #f00;
      }
    }
    .name {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .amount {
      display: flex;
      align-items: center;
      justify-content: space-between;
      label {
        min-width: 80px;
        text-align: right;
        margin-right: 10px;
        &.value {
          &::after {
            content: "万";
            font-size: 50%;
          }
        }
        &.count {
          &::after {
            content: "笔";
            font-size: 50%;
          }
        }
        &.quantity {
          &::after {
            content: "件";
            font-size: 50%;
          }
        }
      }
    }
    :deep(.el-link) {
      white-space: nowrap;
    }
  }
}
</style>